import { Helmet } from 'react-helmet-async';
import textData from '../../../json/text.json';
import seoData from '../../../json/seo.json';

type SeoProps = {
  // ページ名（未指定時はトップページ用タイトル）
  title?: string;
  description: string;
  // サイトルートからのパス（例: '/concept'）
  path: string;
  // OGP画像のパス（未指定時は共通画像）
  image?: string;
  type?: 'website' | 'article';
};

/**
 * 本文から description 用の文章（最大120文字）を作る。本文が空の場合は fallback を返す
 */
export const toDescription = (text: string | undefined, fallback: string) => {
  const plain = (text ?? '').replace(/\s+/g, ' ').trim();
  if (!plain) {
    return fallback;
  }
  return plain.length > 120 ? `${plain.slice(0, 119)}…` : plain;
};

/**
 * ページごとのタイトル・description・OGP・canonical を設定する
 * @returns
 */
const Seo: React.FC<SeoProps> = ({ title, description, path, image, type = 'website' }) => {
  const siteName = textData['companyName']['ja'];
  const fullTitle = title ? `${title}｜${siteName}` : textData['home.title']['ja'];
  const url = `${seoData.siteUrl}${path}`;
  const imageUrl = `${seoData.siteUrl}${image ?? seoData.defaultImage}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:locale" content="ja_JP" />
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
};

export default Seo;
